import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import {
  urlAlterarStatusEntrega,
  urlDelivery,
  urlGetBateriasByFleet,
  urlGetChatByDelivery,
  urlGetChatByFleet,
  urlGetClientesComEntregasCarregadasParaRoteirizacao,
  urlGetClientesComEntregasParaRoteirizacao,
  urlGetDeliveriesStatus,
  urlGetDeliveryByIdentifierLike,
  urlGetDeliveryByInvoiceNumberLike,
  urlGetDeliveryHome,
  urlGetDeliveryHomeByProduct,
  urlGetEntregasParaCte,
  urlGetEntregasPorEmpresa,
  urlGetEntregaTimeline,
  urlGetGeolocationClientsByFleet,
  urlGetNotasFiscaisDevolucao,
  urlGetOcorrenciasEntregaPorEntrega,
  urlGetRouteChatByFleet,
  urlGetRouteChatUnread,
  urlGetTagPallet,
  urlMissingProductByDeliveryId,
  urlPostDeliveryCicleConsolidado,
  urlDownloadCanhotosGestao,
  urlIdsEntregasCanhoto,
  urlRelacaoEntregasCanhoto,
  urlRelacaoTransportadoraCanhoto,
  urlResumoEntregasCanhoto,
  urlTimelineInfoToExport,
  urlUpdateDelivery,
  urlUpdateDeliveryIdentifierAndInvoiceNumberByTp,
  urlUpdateMultipleDelivery,
} from '../../routes/deliveries.routes'

export async function getDelivery(delivery_id) {
  try {
    const response = await authHttp().get(urlDelivery(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveryByIdentifierLike(company_id, identifier) {
  try {
    const response = await authHttp().get(urlGetDeliveryByIdentifierLike(company_id, identifier))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveryByInvoiceNumberLike(company_id, invoice_number) {
  try {
    const response = await authHttp().get(
      urlGetDeliveryByInvoiceNumberLike(company_id, invoice_number),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveryHome(user_id, tp_id, identifier) {
  try {
    const response = await authHttp().get(urlGetDeliveryHome(user_id, tp_id, identifier))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveryHomeByProduct(user_id, tp_id, product) {
  try {
    const response = await authHttp().get(urlGetDeliveryHomeByProduct(user_id, tp_id, product))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateMultiplesDeliveries(deliveries, tp_id) {
  try {
    const response = await authHttp().put(urlUpdateMultipleDelivery(tp_id), deliveries)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateDelivery(delivery) {
  try {
    const response = await authHttp().put(urlUpdateDelivery(), delivery)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateDeliveryIdentifierAndInvoiceNumberByTp(tp_id, data) {
  try {
    const response = await authHttp().put(
      urlUpdateDeliveryIdentifierAndInvoiceNumberByTp(tp_id),
      data,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getMissingProductByDeliveryId(delivery_id) {
  try {
    const response = await authHttp().get(urlMissingProductByDeliveryId(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Entregas Por Empresa - Analítico
export async function getDeliveriesPerCompany(tp_id, company_id, p_inicial, p_final) {
  try {
    const response = await authHttp().get(
      urlGetEntregasPorEmpresa(tp_id, company_id, p_inicial, p_final),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTimelineInfoToBeExported(tp_id, company_id, p_inicial, p_final) {
  try {
    const response = await authHttp().get(
      urlTimelineInfoToExport(tp_id, company_id, p_inicial, p_final),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveryTimeline(delivery_id) {
  try {
    const response = await authHttp().get(urlGetEntregaTimeline(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getNotasFiscaisDevolucao(delivery_id) {
  try {
    const response = await authHttp().get(urlGetNotasFiscaisDevolucao(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Ocorrências de Entrega associadas à entrega (consulta)
export async function getOcorrenciasEntregaPorEntrega(delivery_id) {
  try {
    const response = await authHttp().get(urlGetOcorrenciasEntregaPorEntrega(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Alterar status da entrega
export async function alterarStatusDeEntrega(
  delivery_step_id,
  user_id,
  old_status_id,
  new_status_id,
) {
  try {
    const response = await authHttp().put(urlAlterarStatusEntrega(), {
      delivery_step_id,
      user_id,
      old_status_id,
      new_status_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Roteirizacao Via Mapa
export async function getClientesComEntregasParaRoteirizacao(tp_id, pInicial, pFinal) {
  try {
    const response = await authHttp().get(
      urlGetClientesComEntregasParaRoteirizacao(tp_id, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientesComEntregasCarregadasParaRoteirizacao(
  tp_id,
  expected_date,
  pInicial,
  pFinal,
) {
  try {
    const response = await authHttp().get(
      urlGetClientesComEntregasCarregadasParaRoteirizacao(tp_id, expected_date, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Gestão de Canhoto
export async function getRelacaoTransportadoraCanhoto(tpId, dataInicial, dataFinal, companyId) {
  try {
    const response = await authHttp().get(
      urlRelacaoTransportadoraCanhoto(tpId, dataInicial, dataFinal, companyId),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postDownloadCanhotosGestao(tpId, payload) {
  try {
    const response = await authHttp().post(urlDownloadCanhotosGestao(tpId), payload)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getRelacaoEntregasCanhoto(tpId, params) {
  try {
    const response = await authHttp().get(urlRelacaoEntregasCanhoto(tpId, params))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getResumoEntregasCanhoto(tpId, params) {
  try {
    const response = await authHttp().get(urlResumoEntregasCanhoto(tpId, params))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getIdsEntregasCanhoto(tpId, params) {
  try {
    const response = await authHttp().get(urlIdsEntregasCanhoto(tpId, params))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesStatus() {
  try {
    const response = await authHttp().get(urlGetDeliveriesStatus())
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesForCte(tp_id, company_id, p_inicial, p_final) {
  try {
    const response = await authHttp().get(
      urlGetEntregasParaCte(tp_id, company_id, p_inicial, p_final),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postDeliveryCiclesConsolidado(data) {
  try {
    const response = await authHttp().post(urlPostDeliveryCicleConsolidado(), data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTagPallet(tp_id, dataInicial, dataFinal) {
  try {
    const response = await authHttp().get(urlGetTagPallet(tp_id, dataInicial, dataFinal))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getGeolocationClientsByFleet(fleet_id) {
  try {
    const response = await authHttp().get(urlGetGeolocationClientsByFleet(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getBateriasByFleet(fleet_id) {
  try {
    const response = await authHttp().get(urlGetBateriasByFleet(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getChatFleet(fleet_id) {
  try {
    const response = await authHttp().get(urlGetChatByFleet(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getChatDelivery(fleet_id) {
  try {
    const response = await authHttp().get(urlGetChatByDelivery(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getRouteChatByFleet(fleet_id) {
  try {
    const response = await authHttp().get(urlGetRouteChatByFleet(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getRouteChatUnread(fleet_ids) {
  try {
    const response = await authHttp().get(urlGetRouteChatUnread(fleet_ids))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
